import styled from "styled-components";

export const FAQSecWrapper = styled.div`
  .faq_row {
    align-items: center;
    margin: -20px;
    @media (max-width: 1199px) {
      margin: -15px;
    }
    @media (max-width: 899px) {
      margin: -5px;
    }
    .cmn_faq_col {
      width: 50%;
      padding: 20px;
      @media (max-width: 1199px) {
        width: 100%;
        padding: 15px;
      }
      @media (max-width: 899px) {
        width: 100%;
        padding: 5px;
      }
    }
    .faq_leftCOl {
      h2 {
        font-size: 60px;
        color: rgb(255, 24, 24);
        @media (max-width: 1199px) {
          font-size: 45px;
        }
        @media (max-width: 899px) {
          font-size: 30px;
        }
        @media (max-width: 599px) {
          font-size: 22px;
        }
      }
    }
  }
`;
